module.exports = __webpack_public_path__ + "Google_logo.5f2f5af.png";